export default __webpack_public_path__ + "static/media/message-facebook-icon.b7769674.svg";